import React, {Component} from 'react';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import FastQuotingCabinetVersionsDataService from "./services/fastquotingcabinetversions.service";
import * as FaIcons from "react-icons/fa";
import { Button, Container, FormControl, FormLabel } from 'react-bootstrap';
import FastQuotingCabinetsList from './FastQuotingCabinetsList';
import { useParams } from "react-router-dom";
import FastQuoteCabinetVersionsList from './FastQuoteCabinetVersionsList';
import MessageBox from './MessageBox';
import TopAndSideBar from './TopAndSideBar';
import { NewHeader } from './AuxiliaryFunctions';


var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const WrapperCabinetFastQuoteVersions = (props) => {
  const params = useParams();
  return <CabinetFastQuoteVersions {...props} id={params.id}/>;
};


class CabinetFastQuoteVersions extends Component {

  constructor(props) {
    super(props);
    this.onChangeCabinetFastQuoteVersionsFilterVersionNum = this.onChangeCabinetFastQuoteVersionsFilterVersionNum.bind(this);
    this.onChangeSortField = this.onChangeSortField.bind(this);
    this.onChangeSortType = this.onChangeSortType.bind(this);
    this.performSearch = this.performSearch.bind(this);
    this.duplicateVersion = this.duplicateVersion.bind(this);

    this.state = {
      listOfCabinetFastQuotesVersions: null,
      CabinetFastQuoteVersionsFilterVersionNum: '',
      SortField: 'id',
      SortType: 'ASC'
    };
  }  

  onChangeSortType() {
    this.setState({
      SortType: (this.state.SortType == 'DESC')?'ASC':'DESC'
    });
    this.performSearch(this.props.id,this.state.CabinetFastQuoteVersionsFilterVersionNum,this.state.SortField,this.state.SortType);    
  }

  onChangeSortField(e) {
    this.setState({
      SortField: e.target.value
    });
    this.performSearch(this.props.id,this.state.CabinetFastQuoteVersionsFilterVersionNum,e.target.value,this.state.SortType);
  }

  onChangeCabinetFastQuoteVersionsFilterVersionNum(e) {
    console.log(e.target.value);
    this.setState({
        CabinetFastQuoteVersionsFilterVersionNum: e.target.value
    });
    this.performSearch(this.props.id,e.target.value,this.state.SortField,this.state.SortType);
  }

  componentDidMount() {
    this.performSearch(this.props.id,this.state.CabinetFastQuoteVersionsFilterVersionNum, this.state.SortField,this.state.SortType);  
  }

  performSearch = (id,descr,sortfield,sorttype) => {
    FastQuotingCabinetVersionsDataService.getFastQuotingCabinetVersionsByDescr(id,descr,sortfield,sorttype)
      .then(response => {
        console.log(response.data);
        this.setState({
          listOfFastQuotingCabinetVersions: response.data
        });
        console.log(this.state.listOfFastQuotingCabinetVersions);
      })
      .catch(e => {
        console.log(e);
      });
  };

  duplicateVersion = (fastquotingcabinetId, id) => { 
    // check if fastquoting is associated to a kitchen design

    // fastquotingcabinetId is the id of the fastquotingcabinet
    // id is the field value of the record to duplicate in the fastquotingcabinetversions table
    FastQuotingCabinetVersionsDataService.getAll(fastquotingcabinetId) 
    .then(firstresponse => {
      console.log("firstresponse.data");
      console.log(firstresponse.data);
      const versionnumber = firstresponse.data.length+1;
      console.log(versionnumber);

      FastQuotingCabinetVersionsDataService.get(id)
        .then(secondresponse => {
        const rowtoduplicate = secondresponse.data;
        rowtoduplicate.userId = this.props.user.id;
        rowtoduplicate.versionnumber = versionnumber;
        console.log(rowtoduplicate);
        FastQuotingCabinetVersionsDataService.create(rowtoduplicate)
        .then(thirdresponse => {
          window.location.reload();
        })
        .catch(error => {
          console.log(error);
        })
      })
      .catch(err => {
        console.log(err);
      })
    })
    .catch(error => {
      console.log(error);
    })
  }

  searchWithEnter = (event)=> {
    if (event.keyCode === 13) {
      this.performSearch();
    }
  }  

  render (){
    return (
      <>
      <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
        <TopAndSideBar />
        <NewHeader headerTitle={"Cabinet Fast Quote Versions"}/>
        <div style={{padding:"0 8vw",}}>
          <Container>
            <Row className='mb-2 d-flex'>
              <Col lg={true}>
                <FormLabel className='mb-2'>Filter by Version Number:</FormLabel>       
                <FormControl type="text" name="filterbyquoteversion" id="filterbyquoteversion" onChange={this.onChangeCabinetFastQuoteVersionsFilterVersionNum}></FormControl>
              </Col>
              <Col lg={true}>
                <FormLabel className='mb-2'>Sort By:</FormLabel>       
                  <FormControl as='select' onChange={this.onChangeSortField}>
                    <option value="id">Quote Version</option>
                    <option value="createdAt">Created At</option>
                    <option value="totalquoteversion">Total Amount</option>
                  </FormControl>
              </Col>
              
              <Col sm={true}>
                <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
                <FormControl style={{maxWidth:"50px"}} as="button" onClick={this.onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
              </Col>          
            </Row>
            <Link to="/new-cabinet-fast-quote" className="mr-2 btn btn-primary">New Cabinet Fast Quote</Link>            
            <Button className="m-2 btn btn-primary">Export</Button>        
            <Row>
              <FastQuoteCabinetVersionsList 
                mode={0} 
                listOfFastQuotingCabinetVersions = {this.state.listOfFastQuotingCabinetVersions} 
                duplicateVersion= {this.duplicateVersion}
              />      
            </Row>
          </Container>
        </div>
      </div>
      </>
    )
  }
}

export default WrapperCabinetFastQuoteVersions;